import DateComponent from "./Date"

export interface Props {
  disabled?: boolean

  onChange: (value: string) => void
  label: string
  value?: Date | string | null
}

export interface ComponentProps extends Props {}

export default DateComponent
